<template>

  <ManufacturerList 
    :categoryRoute="routes.category"
    :routes="routes"
    :featured="featured"
    :cart_items="cart_items"
    :productLink="productLink" 
    :isWholesale="isWholesale"
    @getCartItems="getCartItems"
  />

  <div class="d-flex flex-column">
    <div class="mb-0 mb-3 mb-lg-0 order-last order-lg-first">
      <FeaturedProducts
        :is_suggested="true"
        suggested_type="buy_again"
        title="Buy it Again"
        info="Friendly reminder of past items you may need to reorder."
        :routes="routes"
        :products="buy_again_render"
        :cart_items="cart_items"
        :productLink="productLink"
        :isWholesale="isWholesale"
        :viewAllSelected="shownProductsType === 'buy_again'"
        @viewAllButtonClicked="suggested_type => changeProducts(buy_again, suggested_type)"
        @getCartItems="getCartItems"
      />

      <FeaturedProducts
        :is_suggested="true"
        suggested_type="popular"
        title="Popular Items"
        info="Most Popular items in Mobile Tool Network"
        :routes="routes"
        :products="popular_render"
        :cart_items="cart_items"
        :productLink="productLink"
        :isWholesale="isWholesale"
        :viewAllSelected="shownProductsType === 'popular'"
        @viewAllButtonClicked="suggested_type => changeProducts(popular, suggested_type)"
        @getCartItems="getCartItems"
      />

      <FeaturedProducts
        :is_suggested="true"
        suggested_type="suggested"
        title="Recommended for You"
        info="Item suggestions based on previous items purchased"
        :routes="routes"
        :products="suggested_render"
        :cart_items="cart_items"
        :productLink="productLink"
        :isWholesale="isWholesale"
        :viewAllSelected="shownProductsType === 'suggested'"
        @viewAllButtonClicked="suggested_type => changeProducts(suggested, suggested_type)"
        @getCartItems="getCartItems"
      />
    </div>
    <div v-if="renderTimeCheck('afterspotlight')"></div>
    <section class="product-list row mt-2 mb-3 mb-lg-5 mb-lg-3 pb-2 pb-lg-0 px-2 order-first order-lg-last">
      <div class="w-100 mb-3" v-if="$page.props.custom">
        <h3 class="w-100 ml-2 mb-1">Products provided by {{$page.props.auth.user.company_name}}</h3>
        <p @click="clearCustom" class="text-primary cursor-pointer mb-1"><i class="fas fa-long-arrow-alt-left mr-2 ml-2"></i>Go Back to All Products</p>
      </div>

      <h4 v-if="$page.props.query && !products.length" class="alert alert-dark ml-2">
        No results for <strong>{{$page.props.query}}</strong>
      </h4>
      
      <div v-if="!!products.length" class="px-0 px-sm-1 mb-2 col-md-12">
        <div class="d-flex justify-content-end form-inline">
          <div class="form-group">
            <label class="mx-2 small">Sort by</label>
            <select class="form-control form-control-sm" @change="changeSort" v-model="sortBy">
              <option value="newest">Newest</option>
              <option value="sale30day">Top Seller</option>
            </select>
          </div>
        </div>
      </div>

      <template v-for="product in shownProducts || products" :key="product.id">
        <ShopItem
          class="col-sm-6 col-md-4 col-xl-3"
          :product="product"
          :selectedAttribute="product.attributes ? selectedAttribute : null"
          :productLink="productLink"
          :cart_items="cart_items"
          :isWholesale="isWholesale"
          :custom="$page.props.custom"
          :routes="routes" 
          @updateCartItems="updateCartItems"
          @getCartItems="getCartItems"
        />
      </template>
    </section>
    <div v-if="renderTimeCheck('afterlist')"></div>
  </div>
</template>

<script>
  import ManufacturerList from '@/Components/Shop/ManufacturerList'
  import ShopItem from '@/Components/Shop/ShopItem'
  import FeaturedProducts from '@/Components/Shop/FeaturedProducts'

  export default {
    data() {
      return {
        timeCheck: (new Date().valueOf()),
        selectedAttribute: {},
        shownProducts: this.products,
        shownProductsType: null,
        popular_render: this.popular ? this.popular.slice(0,12) : [],
        buy_again_render: this.buy_again ? this.buy_again.slice(0,12) : [],
        suggested_render: this.suggested ? this.suggested.slice(0,12) : [],
        sortBy: 'newest',
      }
    },
    components: {
      ManufacturerList,
      ShopItem,
      FeaturedProducts
    },
    props: {
      products: Array,
      productLink: String,
      routes: Object,
      cart_items: [Boolean, Array],
      popular: Array,
      buy_again: Array,
      suggested: Array,
      featured: Array,
      isWholesale: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      this.changeSort();
    },
    created() {
      this.updateProductList()
      this.makeSelectedAttributes()

      this.getCartItems()

      // Enable bootstrap 4 popovers
      $(function () {
        $('[data-toggle="popover"]').popover({position: 'bottom'})
      })

    },
    methods: {
      changeSort() {
        switch (this.sortBy) {
          case 'newest':
            this.shownProducts.sort((a, b) => a.created_at == b.created_at ? 0 : a.created_at > b.created_at ? -1 : 1)
            break;
          case 'sale30day':
            this.shownProducts.sort((a, b) => a.my_count_30 == b.my_count_30 ? 0 : a.my_count_30 > b.my_count_30 ? -1 : 1)
            break;
          default:
            this.shownProducts.sort((a, b) => a.created_at == b.created_at ? 0 : this.subCompare(a, b))
            break;
        }
      },
      subCompare(a, b) {
        return a.created_at > b.created_at ? -1 : 1
      },
      renderTimeCheck(label) {
        if (window.ENV != 'production') console.log(label, (new Date().valueOf()) - this.timeCheck);
      },
      clearCustom() {
        this.$inertia.visit(this.route(this.route().current()))
      },
      getCartItems() {
        // Update variation cart items(i.e 4 red, 2 green) on each product
        this.shownProducts.forEach(variationProduct => {
          variationProduct.cartItemOptions = []
          this.cart_items.forEach(item => {
            if (item.variation_product_id === variationProduct.id) {
              variationProduct.cartItemOptions.push(item)
            }
          })
        })
      },
      makeSelectedAttributes() {
        const filteredProducts = this.products.filter(product => { return product.attributes && product.attributes.length === 1 })

        filteredProducts.forEach(product => this.selectedAttribute[product.id] = 0)
      },
      changeProducts(prop, suggested_type) {
        this.shownProductsType = suggested_type
        this.shownProducts = suggested_type ? prop : this.products
        this.changeSort()
      },
      findItemFromCart(product) {
        for (let i = 0; i < this.cart_items.length; i++) {
          if (this.cart_items[i].product.id === product.id) {
            return this.cart_items[i]
          }
        }
      },
      updateCartItems() {
        this.products.forEach(product => {
          if (product.attributes.length) {
            product.cartItemOptions = []
            this.cart_items.forEach(item => {
              if (item.variation_product_id === product.id) {
                product.cartItemOptions.push(item)
              }
            })
          }
          
          this.cart_items.forEach(item => {
            item.includes.forEach(included => {
              if (included.included_product_id == product.id) {
                product.cartItemWithThisProduct = item
                product.cartItemWithThisProductQty = included.qty
              }

              if (item.variation_product_id === product.id) {
                product.cartItemOptions.push(item)
              }
            })
          })
        })
      },
      updateProductList() {
        this.products.forEach(product => {
          product.qtyUserInput = false;
          product.ordered_qty = 1
          product.cart_item_id = 0
          product.cartItemOptions = []

          if (product.short_description && product.short_description.length > 90) {
            product.short_description = product.short_description.substr(0,90)
            product.short_description += " ..."
          }

          const cartItem = this.findItemFromCart(product)
          if (cartItem) {
            product.ordered_qty = cartItem.linked_qty
            product.cart_item_id = cartItem.cart_item_id
          }

          this.cart_items.forEach(item => {
            item.includes.forEach(included => {
              if (included.included_product_id == product.id) {
                product.cartItemWithThisProduct = item
                product.cartItemWithThisProductQty = included.qty
              }

              if (item.variation_product_id === product.id) {
                product.cartItemOptions.push(item)
              }
            })
          })
        })
      },
    } 
  }
</script>
